<template>
<div class="taco-container">
<v-toolbar dark class="primary no-print">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>home</v-icon>
    </v-btn>
    <v-toolbar-title>{{liveTransaction.details.clients}} {{lender}} Documents

        <v-menu offset-y :nudge-bottom="8" left>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon>
                <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
            </template>
            <v-list>

                <v-list-item v-for="lender in lenders" :key="lender.name" @click="setLender(lender.name)">
                    <v-list-item-title>{{ lender.name }}</v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item key="general" @click="setLender('General')">
                    <v-list-item-title>General Options</v-list-item-title>
                </v-list-item>                
            </v-list>
        </v-menu>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
        <v-btn v-on="on" dark icon @click="showEmail">
            <v-icon>email</v-icon>
        </v-btn>
        </template>
        <span>Email Client</span>
    </v-tooltip>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
        <v-btn v-on="on" dark icon @click="goToTransaction">
            <v-icon>ballot</v-icon>
        </v-btn>
        </template>
        <span>Go to Transaction</span>
    </v-tooltip>

    <v-menu bottom left :nudge-width="200">
        <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" dark>
            <v-icon>more_vert</v-icon>
        </v-btn>
        </template>
        <v-list>            
            <v-list-item @click="goToTransaction"> 
                <v-list-item-title>Go to Transaction</v-list-item-title>
            </v-list-item>            
        </v-list>
    </v-menu>
    
</v-toolbar>

<!--  -->



 
<div class="taco-content"> 
<v-col md="4" sm="12" class="no-print taco-column">   

<!-- ***************************** Left Column ****************************** -->

<div style="padding: 20px 20px 15px 20px">
    <v-text-field v-model="search" ref="searchText" hide-details label="Search"></v-text-field>
</div>
            
<div style="padding:3px 10px 3px 10px" v-for="category in categories" :key="category['.key']">
    <div style="font-size:1.3em;padding:0px 10px 0px 10px">
        <v-btn style="float:right;margin-top:-5px" icon class="primary--text" @click.native.stop="showDialog(null, category)">
            <v-icon style="font-size:2.1em">add_circle</v-icon>
        </v-btn>        
        {{category.name}}
    </div>

    <div class="hide-scroll" style="width:100%">
   
    <div class="hide-scroll-inner" style="max-height:196px;">
    <div v-for="requirement in requirementsForCategory (category.name)" :key="requirement['.key']">
        <div @click="itemClicked(requirement)" class="truncate pa-2 ma-2 border-grey hoverable clickable" :class="{'blue-hilight': collectionContainsKey(selectedItems, requirement['.key'])}">
            {{requirement.name}}
        </div>
    </div>
    </div>
    </div>
</div>

</v-col>

<!-- ******************  Right Column ****************************** -->

<v-col md="8" sm="12">

<v-row wrap style="height:100%">
<v-col md="8" sm="12" class="taco-column">  <!--Inner left column-->


<div class="pa-3">

    <!-- Empty record indicator -->

    <div class="text-xs-center" style="margin-top:30px;width:100%;text:align:center" v-if="selectedItemsSorted.length == 0">
        <v-icon class="grey--text text--lighten-2" style="font-size:300px">layers</v-icon>
        <p style="margin:20px;font-size:1.3em" class="grey--text text--lighten-1">No items. Click on the document types to the left to start your list</p>
    </div>

    <!-- Checklist -->

    <div ref="checklist">
        <template v-for="item in selectedItemsSorted">
            <div @click.stop="listItemClicked(item)" class="border-transparent transition clickable hoverable"  :class="{'blue-hilight': item['.key'] == activeItem}" :key="item['.key']" style="color:#444;padding:7px 15px 7px 15px">
                <template v-if="!item.notRequired">
                    <template v-if="!item.received && !item.checked">

                        <b style="margin-bottom:2px"><span v-if="item.flag">({{item.flag}}) </span>{{item.name}}</b>
                        <span v-if="!item.received && !item.checked" class="elevation-1" style="background-color:darkorange;padding:2px 5px 2px 5px; border-radius:3px;color:white;font-weight:bold;margin-left:4px;font-size:0.85em;white-space:nowrap">{{item.requirementName}}</span>
                        <template v-if="item.description">
                            <br/> {{item.description}}
                        </template>

                        <template v-if="item.note">
                            <br/><span style="padding:2px 5px 2px 5px;background-color:yellow">{{item.note}}</span>
                        </template>    

                        <template v-if="item.download">
                            <br/>
                            <a @click.stop="false" :href="item.download" target="_blank">
                            <button style="margin-top:5px; margin-bottom:0px; color: #444 ;background-color:white;border-radius:3px;border:solid 1px #c0c0c0; padding:5px 18px 5px 18px;user-select: none;">Download</button>
                            </a>
                        </template>
                    </template>
                    <template v-else>
                        <b style="margin-bottom:2px;color:#444"><span v-if="item.flag">({{item.flag}}) </span>{{item.name}}</b>
                        <span v-if="item.received" class="elevation-1" style="background-color:darkgreen;padding-top:2px;padding:2px 5px 2px 5px; border-radius:3px;color:white;font-weight:bold;margin-left:4px;font-size:0.85em;white-space:nowrap">Received</span>
                        <span v-if="item.checked" class="elevation-1" style="background-color:darkgreen;padding:2px 5px 2px 5px; border-radius:3px;color:white;font-weight:bold;margin-left:4px;font-size:0.85em;white-space:nowrap">Checked</span>
                        <span v-if="documentExpired(item)" class="elevation-1" style="background-color:darkred;padding:2px 5px 2px 5px; border-radius:3px;color:white;font-weight:bold;margin-left:4px;font-size:0.85em;white-space:nowrap">{{documentExpired(item)}}</span>
                    </template> 
                </template>
                <template v-else>
                    <i class="grey--text">{{item.description}}</i></template>
            </div>
        </template>
    </div>
        <!-- Clipboard button -->

    <v-btn dark v-if="selectedItems.length" v-on="on" rounded color="blue lighten-1" @click.native="copyToClipboard" >
        Copy to Clipboard
    </v-btn> 


    <v-tooltip right class="no-print">
        <template v-slot:activator="{ on }">
        <v-btn v-if="selectedItems.length" v-on="on" rounded color="blue lighten-2" @click.native="showEmail" >
            Copy to Clipboard
        </v-btn> 
        </template>
        <span>Email to Client</span>  
    </v-tooltip>
    <br/>

</div>
            
</v-col>

<!-- Inner right column -->
<v-col v-if="transactionKey" md="4" sm="12" class="pa-3 no-print" row>
    <div class="heading">Next Followup</div>
    {{followUpTask.due | dueString}}
    <Scheduler v-model="followUpTask.due" @change="saveFollowupTask" />
    <UserChooser v-model="followUpTask.assigned" label="Assigned To" @select="saveFollowupTask"/>

    <div class="heading mt-4 mb-2">Checklist Comments</div>

    <TransactionComments/>

    <!-- To bring back progress!! -->

    <!-- <div class="center-text mt-4" v-if="step.progress && step.progress.completeCount > 0 && step.progress.totalCount > 0">
        <v-progress-circular :size="40" :width="10" :rotate="-90" :value="(step.progress.completeCount / step.progress.totalCount * 100)"
        class="primary--text"></v-progress-circular><br/><span class="grey--text">{{step.progress.completeCount + ' of ' + step.progress.totalCount + ' received'}}</span>
    </div> -->


</v-col>
</v-row>

</v-col>
</div>

<!--Dialog-->

<v-dialog max-width="500"  v-model="dialogVisible" :fullscreen="$vuetify.breakpoint.smAndDown" transition="v-fade-transition" :hide-overlay="true" scrollable>

<div :style="{height: dialogHeight}" class="dialog-container">

    <div class="dialog-header">

    </div>

    <div class="dialog-body">

        <v-tabs color="primary" v-model="dialogTab" id="mobile-tabs-1" dark>
            <!-- grow scroll-bars dark> -->
            
            <v-tab :key="1">
                Details
            </v-tab>
            <v-tab :key="2">
                Advanced
            </v-tab>
            <v-tab :key="3">
                Checklist
            </v-tab>        
           

            <v-tab-item :key="1">
            
                <div style="height:400px">
                <v-card-text>
                    <v-text-field v-model="documentName" hide-details name="document-name" label="Document Name"></v-text-field>
                    <v-textarea v-model="documentDescription" hide-details rows="3" name="document-description" label="Description" />
                    <v-text-field v-model="documentNote" name="document-note" label="Special Note" hide-details></v-text-field>
                    <br/>Flag&nbsp;&nbsp; 
                    <v-btn-toggle text v-model="documentFlag">
                        <v-btn text value="LATER" key="LATER">Later</v-btn>
                        <v-btn text v-show="couple" :value="client1">{{client1}}</v-btn>
                        <v-btn text v-show="couple" :value="client2">{{client2}}</v-btn>
                        <v-btn text v-show="couple" value="BOTH" key="BOTH">Both</v-btn>
                    </v-btn-toggle>
                    <br/>
                    <v-row>
                        <v-col>
                            <v-switch v-model="documentReceived" color="primary" style="margin-top:15px" xhide-details label="Received"></v-switch> 
                        </v-col>
                        <v-col>
                            <v-switch style="margin-top:15px" color="primary" hide-details label="Checked" v-model="documentChecked"></v-switch>
                        </v-col>
                        <v-col xs5>
                            <v-menu :close-on-content-click="true" v-model="dialogDateMenu" transition="scale-transition" offset-y full-width :nudge-left="40" max-width="290px" >
                                <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" label="Document Date" :value="documentDateString" prepend-icon="event" readonly ></v-text-field>
                                </template>
                                <v-date-picker v-model="documentDate" no-title scrollable actions>
                                    <template scoped-slot="{ clear }">
                                    <div style="text-align:center;margin-top:-50px">
                                        <v-btn text primary @click.native="documentDate = null">Clear</v-btn>
                                    </div>
                                    </template>                                
                                </v-date-picker> 
                            </v-menu> 
                        </v-col>
                    </v-row>
                </v-card-text>
                </div>
            </v-tab-item>

            <v-tab-item :key="2">
                <div style="height:400px">
                <v-card-text height="100%">
                    <v-text-field v-model="documentDownload" name="document-download" label="Download Link" ></v-text-field> 
                    <v-text-field v-model="documentExpiryDays" name="document-expiry-days" label="Days to Expire" ></v-text-field> 
                    <v-textarea v-model="documentInstructions" rows="8" name="document-description" label="Instructions"></v-textarea>
                </v-card-text>
                </div>
            </v-tab-item>

            <v-tab-item :key="3">
                <div style="height:400px">
                <v-card-text height="100%">
                    <div v-for="(check, index) in documentChecklist" :key="check.text">
                        <DeleteButton @click="documentChecklist.splice(index,1)" style="float:right"></DeleteButton>
                        <v-text-field hide-details :label="'Check ' + (index + 1)" style="width:85%" v-model="check.text"></v-text-field>
                    </div>
                    <div>
                        <v-text-field @keyup.enter.native="addCheckItem" label="Add Check Item" v-model="newCheckItem"></v-text-field>
                    </div>
                </v-card-text>
                </div>
            </v-tab-item>

        </v-tabs>       
    </div>

    <div class="dialog-footer">
        <DeleteButton v-if="documentKey" @delete="deleteRequirement(documentKey)" style="float:left"></DeleteButton>

        <v-btn text @click.native="dialogSave">Save</v-btn>
        <v-btn text @click.native="dialogCancel">Cancel</v-btn>
    </div>
    
</div>
</v-dialog>

<v-snackbar :timeout="4000" v-model="snackbarshow" >
    {{ snackbar }}
    <v-icon class="white--text">assignment_turned_in</v-icon>
</v-snackbar>

<EmailDialog :settings="emailDialog.settings" :email="emailDialog.email" :returnObject="emailDialog.returnObject"/>
<SupplierDocumentDialog :settings="supplierDocumentDialog.settings" :document="supplierDocumentDialog.document" />


</div>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
//
import clipboard from 'clipboard-js'
import DeleteButton from '@/ui-elements/DeleteButton'
import FirebaseHelpers from '@/helpers/FirebaseHelpers'
import ContactHelpers from '@/helpers/ContactHelpers'
import ElementHelpers from '@/helpers/ElementHelpers'
import StringHelpers from '@/helpers/StringHelpers'
import DataHelpers from '@/helpers/DataHelpers'
import AlertHelpers from '@/helpers/AlertHelpers'
import Scheduler from '@/ui-elements/Scheduler'
import UserChooser from '@/ui-elements/UserChooser'
import TransactionComments from '@/ui-elements/TransactionComments'
import Utilities from '@/helpers/Utilities'
import FireData from '@/data/FireData'
import EmailDialog from '@/ui-elements/EmailDialog'
import SupplierDocumentDialog from './SupplierDocumentDialog'


var db = firebase.database()
var lendersRef = db.ref('app/lenders')
var categoriesRef = db.ref('app/documents/categories')
var requirementsRef = db.ref('app/documents/requirements')
var requestsRef = db.ref('app/documents/requests/General')
var generalRequestsRef = db.ref('app/documents/requests/General')
import { dateFormats } from '../../helpers/DateHelpers'
import { format } from 'date-fns'


export default {
    name: 'SupplierChecklist',
    props: {
            tenantKey: String,
            transactionKey: String
    }, 

    components: {
        SupplierDocumentDialog,
        DeleteButton,
        Scheduler,
        UserChooser,
        EmailDialog,
        TransactionComments
    },
    data() {
        return {
            supplierDocumentDialog: {
                settings: {
                    visible: false,
                },
                document: {}
            },
            dialogTab: 0,
            followUpTask: {
                code: 'document-checklist',
                title: 'Follow up document checklist',
                due: null,
                assigned:null,
                transactionKey: this.transactionKey
            },
            transactionFields: [],
            //expanded: false,
            snackbar: '',
            snackbarshow: false,
            search: '',
            selectedItems: [],
            activeItem: '',
            lender: 'General',
            newCheckItem: '',
            liveTransaction: {
                details:{}
            },
            
            //dialog items

            dialogVisible: false,
            dialogDateMenu: false,
            documentKey: '',
            
            documentName: '',
            documentDescription: '',
            documentDownload: '',
            documentImportance: 0,
            documentInstructions:'',
            documentReceived: false,
            documentChecked: false,
            documentChecklist: [],
            documentDate: null,
            documentExpiryDays: null,
            documentFlag: '',
            documentNote: '',

            emailDialog: {
                  email: {
                        to: null,
                        cc: null,
                        bcc: null,
                        subject: null,
                        body: '',
                    },
                    settings: {
                        visible: false,
                        customFields: {
                            checklist: null
                        }
                    },
                    returnObject: null,
            },

            newActivity: null
            
        }
    },

    firebase: {
            lenders: lendersRef,
            categories: categoriesRef,
            requirements: requirementsRef,
            requests: requestsRef,
            generalRequests: generalRequestsRef,
    }, 
    watch: {
        selectedItems: function() {
            this.updateProgress()
        }
    },       
    computed: {

        dialogHeight() {
            if(this.$vuetify.breakpoint.smAndDown)
                return '100%'
            else
                return '500px'
        },
        clients () {
            if(this.liveTransaction.clients.length)
                return this.liveTransaction.clients                
            else    
                return []
        },
        recipients () {
            return this.clients.filter(o => o.email).map(o => {
                let recipient = {...o}
                recipient.role = 'Client'
                recipient.fullName = ContactHelpers.fullName(recipient)
                return recipient
            })
        },
        client1 () {
            if(this.clients.length)
                return this.clients[0].firstName.toUpperCase()
            else
                return 'CLIENT 1'
        },
        client2 () {
            if(this.clients.length > 1)
                return this.clients[1].firstName.toUpperCase()
            else
                return 'CLIENT 2'
        },            
        selectedItemsSorted () {
            let result = this.selectedItems.filter (o => o.type=='d')
            result = result.sort((a, b) => b.importance - a.importance)
            return result
        },
        selectedCommentsSorted () {
            let result = this.selectedItems.filter (o => o.type=='c')
            
            //sort by key descending - recent first
            result = result.sort((a, b) => (a['.key'] < b['.key']) - (a['.key'] > b['.key']) )
            return result
        },            

        activityRef () {
            //activities of type d(ocument)
            return this.getTransactionRef().child('activities').orderByChild('type').equalTo('d')
        },

        documentDateString: function () {
            if(this.documentDate) {
                console.log('calcing date')
                //return moment(this.documentDate).format('DD/MM/YY')
                return format(DateHelpers.backwardsToDate(this.documentDate), dateFormats.AUSTRALIAN)
            } else    
                return ''
        },
        couple () {
            return (this.clients.length > 1)
        },
        flagOptions () {
            let arr = []

            arr.push({ text: 'LATER', value: 'LATER' })
            
            if(this.liveTransaction.clients.length > 1) {
                let firstName = this.liveTransaction.clients[0].firstName
                arr.push({ text: firstName, value: firstName })
                firstName = this.liveTransaction.clients[1].firstName
                arr.push({ text: firstName, value: firstName })
                arr.push({ text: 'BOTH', value: 'BOTH' })
            }

            
            
            return arr
        }

    },  
    methods: {
        goToTransaction() {
            this.$router.push('/' + this.tenantKey + '/transaction/' + this.transactionKey)
        },

        stamp(activity) {
            let stampString = DataHelpers.formatStamp(activity.stamp)
            return stampString
        },            

        showEmail () {
            Utilities.log('showEmail')
            this.emailDialog.email.to = this.recipients
            this.emailDialog.settings.group = 'Checklist'
            this.emailDialog.settings.template = 'Followup'
            this.emailDialog.returnObject = null
            this.emailDialog.settings.customFields.checklist = this.$refs.checklist.innerHTML
            // this.emailDialog.attachments = [] //dont need now. checks this in email dialog
            this.emailDialog.settings.visible = true   
        },

        updateProgress () {

            return
            //old

            // if(!this.step['.key'])
            //     return

            // let progress = {
            //     totalCount: this.selectedItemsSorted.length,
            //     completeCount: this.selectedItems.filter(o => o.received == true).length
            // }

            // this.getTransactionRef().child('steps').child(this.step['.key']).child('progress').update(progress)

            // if(this.step.due && this.step.taskKey) {    
            //     this.getTenantRef().child('tasks').child(this.step.taskKey).child('progress').update(progress)
            // }
        },

        emailsFromClients(clients) {
            if(!clients || clients.length == 0)
                return ''
            if(clients.length == 1)
                return clients[0].email || ''

            return (clients[0].email || '') + 
                (clients[0].email && clients[1].email ? ',' : '') + 
                (clients[1].email || '')
        },

        documentExpired (doc) {
            
            if(!doc.expiryDays)
                doc.expiryDays = 30
                // return ''
            
            //let expiryMoment = moment(doc.documentDate, "YYYY-MM-DD").add(doc.expiryDays, 'days')
            const expiryDate = addDays(DateHelpers.backwardsToDate(doc.documentDate), doc.expiryDays)

            //let days = expiryMoment.diff(moment() , 'days')
            let days = addDays(new Date(), expiryDate)
            
            if(days < 7)
                if(days > 0)
                    return 'Expires ' +  days + 'd'
                else if(days == 0)
                    return 'Expired Today'
                else
                    return 'Expired ' + Math.abs(days) + 'd ago'
            else
                return ''
        },

        getActivityRef () {
            return this.getTransactionRef().child('activities')
        },

        getTenantRef () {
            return db.ref('tenants').child(this.$store.getters.tenantKey)
        },

        getTransactionRef () {
            return this.getTenantRef().child('transactions/' + this.transactionKey)
        },

        listItemClicked(item){
            this.showDialog(item)
        },

        itemClicked(item) {
            if (!this.collectionContainsKey(this.selectedItems, item['.key'])) {

                let singleItem = this.getSingleItemForLender(this.lender, item['.key'])
                                
                if(!singleItem)
                    singleItem = this.getSingleItemForLender('General', item['.key'])
                if(singleItem){
                    
                    singleItem.importance = item.category.importance + item.importance
                    // singleItem.stepId = this.step['.key']
                    // singleItem.stepKey = this.step['.key']
                    this.insertToList(singleItem)
                }
                    
                
            } else {

                //remove from db
                if(this.transactionKey) {
                    this.getActivityRef().child(item['.key']).remove()
                }

                //remove from list
                this.selectedItems = this.selectedItems.filter(e => e['.key'] != item['.key'])
            }   

            this.quickHilight(item)
            this.search = ""   
        },

        insertToList(item) {
            //console.log('insertToList', item)

            this.selectedItems.push(item)

            item.type = 'd'

            if(this.transactionKey) {
                let ref = this.getActivityRef()
                ref.child(item['.key']).update(FirebaseHelpers.cloneWithoutKey(item))
            }
                
        },

        getSingleItemForLender(lender, key){
                let ref = db.ref('app/documents/requests/').child(lender).orderByChild('requirementKey').equalTo(key)
                //let vm = this
                let singleItem
                ref.on('value', function(snap) {
                    let results = FirebaseHelpers.snapshotToArray(snap) 
                    if(!results.length)
                        return null
                    results.sort((a, b) => b.importance - a.importance)

                    singleItem = results[0]
                    singleItem['.key'] = key
                    
                }); 
                return singleItem               
        },


        collectionContainsKey(col, key){
            return (col.filter(e => e['.key'] == key).length > 0)
        },

        setLender(name) {
            this.lender = name
            var requestsRef = db.ref('app/documents/requests').child(name)
            this.$bindAsArray('requests', requestsRef)
        },
        showDialog (model, category) {
            if(model) {
                this.documentKey = model['.key']
                this.documentName = model.name || null
                this.documentDescription = model.description || null
                this.documentDownload = model.download || null
                this.documentImportance = model.importance || null
                this.documentInstructions = model.instructions || null
                this.documentReceived = model.received || null
                this.documentChecked = model.checked || null
                this.documentChecklist = model.checklist || null
                this.documentRequirementName = model.requirementName || null
                this.documentDate = model.documentDate || null                    
                this.documentExpiryDays = model.expiryDays || null
                this.documentFlag = model.flag || null ,
                this.documentNote = model.note || null                   
            }
                //this.dialog.model = JSON.parse(JSON.stringify(model))
            else {
                // this.dialog.model.importance = category.importance
                // this.dialog.model.requirementName = category.name
                this.documentImportance = category.importance
                this.documentRequirementName = category.name
            }

            this.dialogVisible = true
        },

        showSupplierDocumentDialog(document) {
            this.supplierDocumentDialog.document = document
            this.supplierDocumentDialog.settings.visible = true
        },

        dialogClose () {
            this.dialogVisible = false
            let vm = this
            setTimeout(function () {

                vm.documentKey = '',
            
                vm.documentName = '', 
                vm.documentDescription ='', 
                vm.documentImportance = 0, 
                vm.documentDownload = '', 
                vm.documentInstructions = '', 
                vm.documentChecklist = [],
                vm.documentReceived = false,
                vm.documentChecked = false,
                vm.documentRequirementName = '',
                vm.documentDate = null,
                vm.documentExpiryDays = null,
                vm.documentFlag = '',
                vm.documentNote = '',
                
                vm.dialogTab = '0'
            },300)
        },
        dialogCancel () {
            this.dialogClose()
        },
        dialogSave () {
            this.addOrUpdateItem()
            this.dialogClose()
        },
        deleteRequirement (key) {
            //remove from array
            this.selectedItems = this.selectedItems.filter(o => o['.key'] != key)
            
            this.dialogClose()

            //remove from db
            this.getActivityRef().child(key).remove()
        },


        requirementsForCategory (category) {
            let result =  this.requirements.filter(req => req.category.name == category)
            if(this.search) {
                let regex = new RegExp( this.search, 'i' )
                result = result.filter(req => req.name.match(regex) )
            }
            result = result.sort((a,b) => b.importance - a.importance)
            return result
        },
        requestsForRequirement (type) {

            // let requests =  this.requests.filter(req => req.requirementKey == type && req.name != 'NA')
            let requests =  this.requests.filter(req => req.requirementKey == type)
            requests = requests.sort((a, b) => b.importance - a.importance)
            return requests
        },
        generalRequestsForRequirement (type) {
            //return this.requests
            let requests =  this.generalRequests.filter(req => req.requirementKey == type)
            requests = requests.sort((a, b) => b.importance - a.importance)
            return requests
        },
        addOrUpdateItem() {

            let model = {
                name: this.documentName,
                description: this.documentDescription,
                download: this.documentDownload,
                importance: this.documentImportance,
                instructions: this.documentInstructions,
                received: this.documentReceived || null,
                checked: this.documentChecked || null,
                checklist: this.documentChecklist || null,
                documentDate: this.documentDate || null,
                expiryDays: this.documentExpiryDays || null,
                requirementName: this.documentRequirementName,
                flag: this.documentFlag,
                note: this.documentNote,
                // stepId: this.step['.key'],
                // stepKey: this.step['.key'],
                type: 'd'
            }

            
            
            //existing item

            if(this.documentKey){
                let newArr = []
                newArr.push({...model, '.key': this.documentKey})
                this.selectedItems = this.selectedItems.map(obj => newArr.find(o => o['.key'] === obj['.key']) || obj)
                this.quickHilight({'.key': this.documentKey})
                
                if(this.transactionKey)
                    this.getActivityRef().child(this.documentKey).update(model)
            
            //new item
            
            } else {

                //get a push key (client side only)
                let key = db.ref().push().key

                this.selectedItems.push({...model, '.key': key}) 
                this.quickHilight({'.key': key})
                
                if(this.transactionKey)
                    this.getActivityRef().child(key).set(model)
            }
        },
        addCheckItem() {
            if(!this.documentChecklist)
                this.documentChecklist = []

            this.documentChecklist.push({
                text: this.newCheckItem
            })
            this.newCheckItem = ''
        },
        copyToClipboard () {

            let html = this.$refs.checklist.innerHTML
            
            clipboard.copy({'text/html': html})
            this.snackbar = 'Copied to Clipboard'

            this.snackbarshow = true
        },
        quickHilight (item) {
            let vm = this
            vm.activeItem = item['.key']   
            clearTimeout(window.timer) 
            window.timer = setTimeout(function() {
                vm.activeItem = '' 
            }, 1000);  
        },

        // scheduleStep (newVal) {
        //     let newStep = {due: newVal}
        //     let taskKey = this.step.taskKey
        //     if(!taskKey) {
        //         taskKey = DataHelpers.getKey()
        //         newStep.taskKey = taskKey
        //     }   

        //     this.getTransactionRef().child('steps').child(this.step['.key']).update(newStep)
        //     this.getTenantRef().child('tasks').child(this.step['.key']).update(FirebaseHelpers.cloneWithoutKey(this.step))
        // },

        saveFollowupTask() {
            console.log('saveFollowupTask', this.followUpTask)
            this.$store.dispatch('saveTask', this.followUpTask)
        },

        setSpecialTab(name) {
            const tab = {
                key: name,
                title: StringHelpers.capitalizeFirstLetter(name),
                name: name,
                type: 'Tab'
            }
            this.$store.commit('setSelectedTab', tab)
        },            


    },
    created () {
        
        DataHelpers.initialiseTenant(this.tenantKey)

        //check for contacts existing (temporary)...

        console.log('supplier-checklist > created')
        let vm = this

        this.liveTransaction = {
            details:{},
            people: [], //old
            clients: []
        }

        // Are we in a transaction?
        if(!this.transactionKey)
            return

        // Set up the follow up task
        const fupRef = DataHelpers.getTenantRef().child('tasks').orderByChild('transactionKey').equalTo(this.transactionKey)
        FireData.fetchItems(fupRef).then(tasks => {
            let fupTask = tasks.find(o => o.code == 'document-checklist')
            if(fupTask)
                this.followUpTask = fupTask
        })

        this.setSpecialTab('checklist')

        this.$store.dispatch('loadTransaction', this.transactionKey).then((transaction) => {
                
            Utilities.log('Workflow > initialise - Calling load transaction', transaction)
            
            // Get contacts for transaction (new way)

            this.$store.dispatch('fetchElementsByType', 'Contact').then(contactElements => {

                console.log('celements', contactElements)
                let contacts = ElementHelpers.contactElementsForRole('Client', contactElements).map(o => {
                    return {
                        key: o.contactKey,
                        ...o.contact
                    }
                    
                })
            
                if(contacts && contacts.length)
                    this.liveTransaction.clients = contacts
            
            })

            vm.liveTransaction.details = transaction

            setTimeout( () => {
                
                if(!vm.clients.length)
                    AlertHelpers.showAlert("Old file: Please go into transaction, then add clients as contacts manually")

            },4000)

                
        }).catch(err => {
            Utilities.log('Created > Error in loadTransaction ', err)
            this.snackbar = err
            this.snackbarshow = true
        })

        //Load checklist items from firebase

        vm.getActivityRef().on('value', function (activitySnap) {
            vm.selectedItems = FirebaseHelpers.snapshotToArray(activitySnap)
        })  
    }
}

</script>

<style scoped>

.subtle {
    /*border:solid 1px #ddd;*/
    background-color: #eee;
}

.transition {
    transition: all .5s linear;
    -webkit-transition: all .5s linear;    
}

.hide-scroll {
    overflow: hidden;
}

.hide-scroll-inner {
    overflow: auto;

    /* Make sure the inner div is not larger than the container
     * so that we have room to scroll.
     */
    

    /* Pick an arbitrary margin/padding that should be bigger
     * than the max width of all the scroll bars across
     * the devices you are targeting.
     * padding = -margin
     */
    margin-right: -100px;
    padding-right: 100px;
}

/* todo: remove duplication from this and transaction.vue */

.activity-input {
    padding:10px;
    border: solid 1px #ccc;
    width:100%;
    margin-bottom:4px;
    margin-top:2px;
    color:#444;
}

    .activity {
        color:#444; padding:5px; padding-left:12px;
        border-left:solid 5px #ccc; margin-bottom:10px
    }
    .activity-complete {
        border-left:solid 5px #4caf50;
    }

</style>


// WEBPACK FOOTER //
// SupplierChecklist.vue?4d447968